import React from "react";

type NoticeProps = {
  type: string;
};

const colorClasses = {
  info: "bg-yellow-50 border-l-5 border-yellow-600",
  warning: "bg-red-50 border-l-5 border-red-600",
  tip: "bg-blue-50 border-l-5 border-blue-600",
};

const getColorClass = (type: string) => {
  return colorClasses[type];
};

const Notice: React.FC<NoticeProps> = ({ children, type }) => {
  return (
    <div className={"w-full notice px-6 py-6 rounded " + getColorClass(type)}>
      <div className="text-gray-900 prose prose-lg lg:prose-xl">{ children }</div>
    </div>
  );
};

export default Notice;
